import { apiClient, unwrap } from './client';

import type {
  AnalyticsData,
  ApiResponse,
  JobSubmissionStatus,
  RecommendExercise,
} from '@/types';

export async function getClassAnalytics(classId: number): Promise<AnalyticsData> {
  const response = await apiClient.get<ApiResponse<AnalyticsData>>(`/analytics/class/${classId}`);
  return unwrap(response);
}

/** 作业提交情况：应交/已交/未交统计 + 学生明细名单 */
export async function getJobSubmissionStatus(jobId: number): Promise<JobSubmissionStatus> {
  const response = await apiClient.get<ApiResponse<JobSubmissionStatus>>(
    `/analytics/job/${jobId}/submission-status`,
  );
  return unwrap(response);
}

export async function getRecommendations(studentId: number): Promise<RecommendExercise[]> {
  const response = await apiClient.get<ApiResponse<{ exercises: RecommendExercise[] }>>(
    `/analytics/recommend/${studentId}`,
  );
  return unwrap(response).exercises;
}
